import * as React from "react";

function SvgCheck(props) {
  return <svg fill="none" xmlns="http://www.w3.org/2000/svg" {...props}><path d="M88 44.32V48a40 40 0 11-23.72-36.56" stroke="#3CA540" strokeWidth={7} strokeLinecap="round" strokeLinejoin="round" /><path d="M88 16L48 56.04l-12-12" stroke="#3CA540" strokeWidth={7} strokeLinecap="round" strokeLinejoin="round" /></svg>;
}

export default SvgCheck;